import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'
import { api } from 'api'

export const useRoleMappingsDelete = (id: string) => {
  return useMutation({
    mutationFn: (data) => api.keycloak.deleteUserRoleMappings(id, data),
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось удалить роль',
        type: 'error',
      })
    },
    onSuccess: () => {
      toaster.create({
        title: 'Готово',
        description: 'Роль успешно удалена',
        type: 'success',
      })
    }
  })
}
